module.exports = __webpack_public_path__ + "./assets/7ec364df8f9ba780fd26e82d97868c62.svg";